import {
  GET_PROSPECT_BILLING_INFO_ENDPOINT,
  GET_RECURRING_BILLING_ENDPOINT,
  PASSWORDLESS_LOGIN_RESPONSE_ENDPOINT,
  RESEND_LOGIN_CODE_ENDPOINT,
  VERIFY_EMAIL_CODE_ENDPOINT,
} from '../constants/endpoint';

export default [
  {
    endpoint: PASSWORDLESS_LOGIN_RESPONSE_ENDPOINT,
    messageStart: 'Invalid Code',
    rollbarItem: 'User attempted to log in with invalid session',
  },
  {
    endpoint: PASSWORDLESS_LOGIN_RESPONSE_ENDPOINT,
    messageStart: 'We do not recognize',
    rollbarItem: 'User attempted to log in with the wrong code',
  },
  {
    endpoint: RESEND_LOGIN_CODE_ENDPOINT,
    messageStart: 'Invalid Code',
    rollbarItem: 'Attempted to resend a code with an invalid session',
  },
  {
    endpoint: RESEND_LOGIN_CODE_ENDPOINT,
    messageStart: 'We do not recognize this',
    rollbarItem: 'Attempted to resend a code after max attempts',
  },
  {
    endpoint: GET_PROSPECT_BILLING_INFO_ENDPOINT,
    messageStart: 'Billing History Not Found',
    rollbarItem: 'Billing history not found for user',
  },
  {
    endpoint: GET_RECURRING_BILLING_ENDPOINT,
    messageStart: 'Invoice not found',
    rollbarItem: 'Invoice not found',
  },
  {
    endpoint: VERIFY_EMAIL_CODE_ENDPOINT,
    messageStart: 'Codes do not match',
    rollbarItem: 'Update email codes do not match',
  },
];
